module.exports = __webpack_public_path__ + "img/foot-icon.9a2214f3.png";